// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ef-0";
export var fileCarousel = "_ef-2";
export var removeFileButton = "_ef-1";